import { Injectable, ModuleWithProviders } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SpinnerComponent } from './../shared/spinner.component';

@Injectable()
export class LoaderService {

    constructor() { }
    public isShowProgressBar: Subject<boolean> = new BehaviorSubject<boolean>(null);
    public isShowSpinner: Subject<boolean> = new BehaviorSubject<boolean>(null);

    hideProgressBar() {
        this.isShowProgressBar.next(false);
    }

    showProgressBar() {
        this.isShowProgressBar.next(true);
    }

    hideSpinner() {
        this.isShowSpinner.next(false);
    }

    showSpinner() {
        this.isShowSpinner.next(true);
    }
}




// WEBPACK FOOTER //
// ./src/app/services/loader.service.ts